export default {
    createLeaveType: 'สร้างประเภทการลา',
    updateLeaveType: 'แก้ไขประเภทการลา',
    leaveType: 'ประเภทการลา',
    gender: 'เพศ',
    numberOfDays: 'จำนวนวัน',
    resetDay: 'รีเซตวัน',
    resetMonth: 'รีเซตเดือน',
    employment: 'ประเภทพนักงาน',
    fullTimeLeave: 'พนักงานประจำ',
    personalLeave: 'ลากิจ',
    sickLeave: 'ลาป่วย',
    annualResetDate: 'รีเซ็ทประจำปี',
    saveChanges: 'บันทึก',
    probation: 'พนักงานทดลองงาน',
    probationLeave: 'พนักงานทดลองงาน',
    save: 'บันทึก',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    incorrectPhoneNubmer: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    leaveTypeIsCreated: 'ประเภทการลาถูกสร้างแล้ว',
    leaveTypeIsUpdated: 'ประเภทการลาถูกอัปเดตแล้ว'
}
